<template>

<app-page v-if="is.loaded" :title="title">

	<app-inner class="account-inner" :row="!window.is.mobile">

		<com-menu :expanded="is.expanded" class="account-menu" v-on:toggle="onMenuToggle" v-if="session.terms" />

		<div class="account-content" v-show="!is.expanded || !window.is.mobile">

			<router-view />

		</div>
	
	</app-inner>

</app-page>

</template>

<script>

import mixinPage from '@/mixin/page.js'

import comMenu from './account/Menu'

export default {

    mixins: [mixinPage],
    
    data: function() {

        return {
            is: {
                expanded: false
            }
        }

    },

	components: {
		'com-menu': comMenu
    },

    computed: {

		title: function() {

			if (this.isSessionCustomer) {

				return this.page.customer_title

			} else {

				return (this.session.terms) ? this.page.business_title : 'Complete profile'

			}

		},

        path: function() {

            return this.$route.path

        }

    },

	created: function() {

		if (this.isSessionBusiness && !this.session.terms && this.$route.name !== 'Account/Complete') this.$router.push({
			name: 'Account/Complete'
		})

	},

    watch: {

        path: function() {

            this.is.expanded = false

        }

    },
    
    methods: {

        onMenuToggle: function() {

            this.is.expanded = !this.is.expanded

        }

    }

}

</script>

<style scoped>

.account-menu {
	width: 240px;
	flex-shrink: 0;
}

.is-tablet .account-menu {
    width: 180px;
}

.is-mobile .account-menu {
    width: 100%;
}

.account-content {
	flex-grow: 1;
    flex-basis: 0;
	display: flex;
	flex-direction: column;
}

.is-tablet .account-content {
    width: calc(100% - 240px);
}

</style>